const getSpecificStringFromString = (string, keyword) =>
  string?.replace(keyword, "");

export { getSpecificStringFromString };
